import React from "react";

const KEYWORDS = [
  "Store Credit",
  "Cashback",
  "Refunds",
  "Welcome Credit",
  "Gift Cards",
  "Loyalty Rewards",
  "Store Credit Refunds",
  "Cashback Rewards",
  "Customer Retention",
  "Return Credits",
  "Reward Points",
  "Shopify Store Credit",
  "Credit Balance",
  "Cash Back App",
  "Repeat Purchases",
];

// Duplicate so the loop is seamless
const ITEMS = [...KEYWORDS, ...KEYWORDS];

export default function KeywordTickerComponent() {
  return (
    <div
      className="relative w-full overflow-hidden pb-4"
      style={{ background: "#ffffff" }}
    >
      {/* Left fade */}
      <div
        className="absolute left-0 top-0 bottom-0 z-10 pointer-events-none"
        style={{
          width: 120,
          background: "linear-gradient(to right, #ffffff 30%, transparent)",
        }}
      />
      {/* Right fade */}
      <div
        className="absolute right-0 top-0 bottom-0 z-10 pointer-events-none"
        style={{
          width: 120,
          background: "linear-gradient(to left, #ffffff 30%, transparent)",
        }}
      />

      {/* Ticker track */}
      <div
        style={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          whiteSpace: "nowrap",
          animation: "pbl-ticker 32s linear infinite",
          willChange: "transform",
        }}
      >
        {ITEMS.map((kw, i) => (
          <React.Fragment key={i}>
            <span
              style={{
                color: "#c8c5c0",
                fontFamily: "ui-monospace, 'Courier New', monospace",
                fontSize: "0.7rem",
                fontWeight: 600,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              {kw}
            </span>
            <span
              style={{
                color: "#ddd9d4",
                fontSize: "0.7rem",
                margin: "0 1.5rem",
                flexShrink: 0,
              }}
            >
              ·
            </span>
          </React.Fragment>
        ))}
      </div>

      <style>{`
        @keyframes pbl-ticker {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
